<script setup>
import { computed } from 'vue';

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(
  () => `custom_sla_reports_${props.row.original.type}_show`
);
const hasId = computed(() => !!props.row.original.id);
</script>

<template>
  <router-link
    v-if="hasId"
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
  <span v-else class="text-n-slate-11">{{ row.original.name }}</span>
</template>
